import { render, staticRenderFns } from "./mould_number_change_record.vue?vue&type=template&id=31f40254&scoped=true&"
import script from "./mould_number_change_record.vue?vue&type=script&lang=js&"
export * from "./mould_number_change_record.vue?vue&type=script&lang=js&"
import style0 from "./mould_number_change_record.vue?vue&type=style&index=0&id=31f40254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f40254",
  null
  
)

export default component.exports